import { useMemo } from "react";
import { useSelector } from "react-redux";
import { resolvePlanAccess } from "../utils/planEntitlements";

export function usePlanAccess() {
  const { entitlements, tenant, billing } = useSelector((state) => state.auth);
  return useMemo(
    () => resolvePlanAccess(entitlements, tenant, billing),
    [entitlements, tenant, billing],
  );
}
